import styles from "./Icon.styles.scss";
import IconArrowForward from "../../assets/icons/icon-arrow_forward.svg";
import ChevronDown from "../../assets/icons/icon-chevron_down.svg";
import VolumeOff from "../../assets/icons/icon-volume_off.svg";
import VolumeHigh from "../../assets/icons/icon-volume_high.svg";
import Magnify from "../../assets/icons/icon-magnify.svg";
import PoundBoxOutline from "../../assets/icons/icon-pound_box_outline.svg";
import Check from "../../assets/icons/icon-check.svg";
import CheckAll from "../../assets/icons/icon-check_all.svg";
import Video from "../../assets/icons/icon-video.svg";
import VideoOff from "../../assets/icons/icon-video_off.svg";
import Microphone from "../../assets/icons/icon-microphone.svg";
import MicrophoneOff from "../../assets/icons/icon-microphone_off.svg";
import Message from "../../assets/icons/icon-message.svg";
import Close from "../../assets/icons/icon-close.svg";
import Paperclip from "../../assets/icons/icon-paperclip.svg";
import CloudUpload from "../../assets/icons/icon-cloud_upload.svg";
import Download from "../../assets/icons/icon-download.svg";

const icons = {
  arrow_forward: {
    icon: IconArrowForward,
    className: '',
    style: {}
  },
  arrow_backward: {
    icon: IconArrowForward,
    className: '',
    style: {
      transform: "rotate(180deg)"
    }
  },
  chevron_down: {
    icon: ChevronDown,
  },
  volume_off: {
    icon: VolumeOff
  },
  volume_high: {
    icon: VolumeHigh
  },
  magnify: {
    icon: Magnify
  },
  pound_box_outline: {
    icon: PoundBoxOutline
  },
  check: {
    icon: Check
  },
  check_all: {
    icon: CheckAll
  },
  video: {
    icon: Video,
  },
  video_off: {
    icon: VideoOff,
  },
  microphone: {
    icon: Microphone,
  },
  microphone_off: {
    icon: MicrophoneOff,
  },
  message: {
    icon: Message,
  },
  close: {
    icon: Close
  },
  paperclip: {
    icon: Paperclip,
    style: {
      transform: "rotate(-45deg)"
    }
  },
  cloud_upload: {
    icon: CloudUpload,
  },
  download: {
    icon: Download,
  }
};

const Icon = ({onClick, title = '', name, size = 24, color = "#666", className, style, ref, badge }) => {
  if (!icons[name])
    throw new Error(`Icon not found (name: ${name})`);

  const icon = icons[name].icon;
  let src = '';
  if (typeof icon === "string")
    src = `data:image/svg+xml;utf8,${encodeURIComponent(icon.replace(`fill="#666"`, `fill="${color}"`))}`;

  return src ? <img
    ref={ref}
    title={title}
    className={[icons[name].className, className].join(" ")}
    style={{...icons[name].style, cursor: onClick ? "pointer" : "inherit", ...style}}
    src={src}
    width={size}
    height={size}
    onClick={onClick}
    alt={name}
  /> : <div ref={ref} title={title} className={className} style={{width: size, height: size, display: "flex", position: "relative"}}>
    {icon({
      className: [icons[name].className].join(" "),
      style: {...icons[name].style, cursor: onClick ? "pointer" : "inherit", width: size, height: size, fill: color, ...style},
      onClick,
    })}
    {badge ? <div className={styles.icon}>{badge}</div> : null}
  </div>;
};

export default Icon;



// WEBPACK FOOTER //
// ./components/Icon/Icon.js